import { __ } from '@wordpress/i18n';
import { registerBlockType } from '@wordpress/blocks';

import edit from './edit';
import save from './save';

import { fullWidthSliderIcon } from '../../assets/icons/icons';
import {Icon} from '@wordpress/components';

registerBlockType( 'buba-blocks/slider', {
	apiVersion: 2,
	title: __( 'Slider' ),
	icon: <Icon icon={fullWidthSliderIcon} />,
	category: 'buba',
	attributes:{
		countSlides: {
			type: 'number',
			default: 1,
		},
		autoplay:{
			type: 'boolean',
			default: false,
		},
		autoplaySpeed:{
			type: 'number',
			default: 3000,
		},
		arrows: {
			type: 'boolean',
			default: false,
		},
		dots: {
			type: 'boolean',
			default: false,
		},
		infinite: {
			type: 'boolean',
			default: true,
		},
		fade: {
			type: 'boolean',
			default: false,
		},
		slidesToShow: {
			type: 'number',
			default: 1,
		},
		slidesToScroll: {
			type: 'number',
			default: 1,
		},
		speed: {
			type: 'number',
			default: 500,
		},
		cssEase: {
			type: 'string',
			default: 'ease',
		}
	},
	supports: {
		anchor: true,
		align: [ 'wide', 'full' ],
		alignWide: false,
		lightBlockWrapper: true
	},
	edit,
	save,
} );
